import { useImperativeHandle } from 'react';
export function useTableRef(ref, tableResult) {
    const getSettings = () => {
        var _a;
        return {
            sortingRules: tableResult.tableColumnsResult.sortingRules,
            sortedColumnIds: tableResult.tableColumnsResult.sortedColumnIds,
            visibleColumnIds: tableResult.tableColumnsResult.visibleColumns.map((column) => column.id),
            columnsWidth: tableResult.tableColumnsResult.columnsWidth,
            groupColumnId: (_a = tableResult.tableColumnsResult.groupColumn) === null || _a === void 0 ? void 0 : _a.id,
            isShowTotals: tableResult.tableColumnsResult.isShowTotals
        };
    };
    const getIsShowTotals = () => {
        return tableResult.tableColumnsResult.isShowTotals;
    };
    const setIsShowTotals = (isShowTotals) => {
        tableResult.tableColumnsResult.setIsShowTotals(isShowTotals);
    };
    const getGroupColumn = () => {
        return tableResult.tableColumnsResult.groupColumn;
    };
    const setGroupColumn = (groupColumn) => {
        tableResult.tableColumnsResult.setGroupColumn(groupColumn);
    };
    useImperativeHandle(ref, () => ({
        getSettings,
        getIsShowTotals,
        setIsShowTotals,
        getGroupColumn,
        setGroupColumn,
        setVisibleColumnIds: tableResult.tableColumnsResult.setVisibleColumnsIds,
        getSortedColumnIds: () => tableResult.tableColumnsResult.sortedColumnIds,
        setSortedColumnIds: tableResult.tableColumnsResult.setSortedColumnIds,
        getScrollContainer: () => tableResult.tableVirtualListResult.containerRef.current
    }), [
        tableResult.tableColumnsResult.sortingRules,
        tableResult.tableColumnsResult.sortedColumnIds,
        tableResult.tableColumnsResult.visibleColumns,
        tableResult.tableColumnsResult.columnsWidth,
        tableResult.tableColumnsResult.groupColumn,
        tableResult.tableColumnsResult.isShowTotals,
        tableResult.tableColumnsResult.setVisibleColumnsIds,
        tableResult.tableColumnsResult.setSortedColumnIds,
        tableResult.tableVirtualListResult.containerRef
    ]);
}
